import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';

export const DashboardSearchWrapper = styled(MUIBox)({
  '&': {
    paddingTop: '36px',
    marginBottom: '-4px',
  },
});
